export default __webpack_public_path__ + "static/media/face@2x.9a0c008d.png";